import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";
import { registerExternalSignoutCleanup } from "owa-msaljs";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaHeader"*/ "./lazyIndex"), {
    name: "OwaHeader",
});

export const lazySignout: LazyAction<typeof lazyIndex.signout, typeof lazyModule> = new LazyAction(lazyModule, m => m.signout);

const lazySignoutCleanup: LazyAction<typeof lazyIndex.signoutCleanup, typeof lazyModule> = new LazyAction(lazyModule, m => m.signoutCleanup);

/**
 * Registers owa-signout's comprehensive signout cleanup (offline databases,
 * service-worker cache, Fluid storage, and signout promises) with owa-msaljs so
 * that cross-module callers such as MSAL Activity Timeout and federated logout run
 * the full cleanup.
 *
 * This is invoked from common bootstrap rather than at module scope so that
 * registration happens without a module-scope side effect and without owa-msaljs
 * needing to depend on owa-signout (which would create a circular dependency). The
 * cleanup itself stays in the lazy OwaHeader chunk via importAndExecute().
 */
export function registerSignoutCleanup(): void {
    registerExternalSignoutCleanup(() => lazySignoutCleanup.importAndExecute());
}

export { addSignoutPromise } from "./signoutPromises";
export type { SignoutPromiseCallback } from "./signoutPromises";
